import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import enTranslations from "./locales/en.json";
import viTranslations from "./locales/vi.json";

const getStoredLanguage = (): string => {
  const stored = localStorage.getItem("language");

  if (stored === "vi" || stored === "en") {
    return stored;
  }

  const browserLang =
    navigator.language || (navigator as any).userLanguage || "en";
  const browserLangCode = browserLang.toLowerCase().split("-")[0];

  let selectedLanguage: string;
  switch (browserLangCode) {
    case "vi":
      selectedLanguage = "vi";
      break;
    case "en":
      selectedLanguage = "en";
      break;
    default:
      selectedLanguage = "en";
      break;
  }

  localStorage.setItem("language", selectedLanguage);

  return selectedLanguage;
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    vi: {
      translation: viTranslations,
    },
  },
  lng: getStoredLanguage(), // Default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  react: {
    useSuspense: false, // Disable suspense to avoid issues
  },
});

// Listen for language changes and update i18n
const storedLanguage = getStoredLanguage();
i18n.changeLanguage(storedLanguage);

export default i18n;
